export default function aiFormResults(
  state = {
    data: {},
  },
  action
) {
  switch (action.type) {
    case 'UPDATE_AI_ALL_RESULTS':
      return {
        data: { ...state.data, ...action.data },
      }
    default:
      return state
  }
}
